import { Cancel } from '@cegal/ui-icons/dist/Cancel';
import React from 'react';
const ValueRemove = (props) => {
    const { innerProps } = props;
    return (React.createElement("div", Object.assign({ style: { cursor: 'pointer' } }, innerProps),
        React.createElement(Cancel, { size: props.size === 'medium' ? '1.5rem' : '1.2rem' })));
};
ValueRemove.displayName = 'SelectMultiple.ValueRemove';
export default ValueRemove;
